import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/codepen': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.3 159.7c6 4 9.7 11.1 9.7 18.3v156c0 7.1-3.7 14.3-9.7 18.3l-234 156c-8.1 5-16.6 4.9-24.6 0l-234-156c-6-4-9.7-11.1-9.7-18.3v-156c0-7.1 3.7-14.3 9.7-18.3l234-156c8.1-5 16.6-4.9 24.6 0zM278 63.1v102.6l95.4 63.7 76.9-51.4zM234 63.1l-172.3 114.9 76.9 51.4 95.4-63.7v-102.6zM44 219.1v73.7l55.1-36.9zM234 448.8v-102.6l-95.4-63.7-76.9 51.4zM256 308l77.7-52-77.7-52-77.7 52zM278 448.8l172.3-114.9-76.9-51.4-95.4 63.7v102.6zM468 292.8v-73.7l-55.1 36.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/codepen.js
// module id = 760
// module chunks = 0